import { useState } from "react";
import { format, parseISO } from "date-fns";
import { nb } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { cn } from "@/lib/utils";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * «Vis flåten per dato» – picks the date the map should answer for. Anything but today is an *expected* picture derived
 * from planned allocations, and the callers label it as such.
 */
export const MapDatePicker = ({ date, today, onChange, testId = "map-date-button" }) => {
  const [open, setOpen] = useState(false);
  const isToday = date === today;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "pointer-events-auto inline-flex h-9 items-center gap-1.5 rounded-full bg-card/85 px-3.5 text-[12px] font-medium shadow-[0_0_0_1px_rgba(16,24,40,0.05),0_6px_20px_-8px_rgba(16,24,40,0.28)] backdrop-blur-xl transition-colors duration-150 hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60",
            !isToday && "text-primary"
          )}
          data-testid={testId}
        >
          <CalendarDays className="h-3.5 w-3.5" strokeWidth={1.75} />
          {isToday ? "I dag" : format(parseISO(date), "d. MMM yyyy", { locale: nb })}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0" data-testid={`${testId}-popover`}>
        <Calendar
          mode="single"
          locale={nb}
          selected={parseISO(date)}
          onSelect={(d) => {
            if (d) {
              onChange(format(d, "yyyy-MM-dd"));
              setOpen(false);
            }
          }}
          initialFocus
        />
        <div className="flex items-center justify-between gap-2 px-3 pb-3 text-[12px]">
          <span className="text-muted-foreground">Vis flåten per dato</span>
          {!isToday && (
            <button
              type="button"
              onClick={() => {
                onChange(null);
                setOpen(false);
              }}
              className="link"
              data-testid={`${testId}-today`}
            >
              I dag
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
